import { render, staticRenderFns } from "./CartDetails.vue?vue&type=template&id=d8a9fdf0"
import script from "./CartDetails.vue?vue&type=script&lang=js"
export * from "./CartDetails.vue?vue&type=script&lang=js"
import style0 from "./CartDetails.vue?vue&type=style&index=0&id=d8a9fdf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports